import { atom } from "recoil";

export const speechRecognizeState = atom({
  key: "speechRecognizeState",
  default: null,
});
